import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";

import { Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

interface SyncConfirmDialogProps {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  title: string;
  confirmAction: () => void;
  disabled: boolean;
  syncOrg: string;
}

export const SyncConfirmDialog: React.FC<SyncConfirmDialogProps> = ({
  dialogOpen,
  setDialogOpen,
  title,
  confirmAction,
  disabled,
  syncOrg,
}) => {
  return (
    <Dialog
      size="xl"
      open={dialogOpen}
      setOpen={setDialogOpen}
      title={title}
      primaryButton={{
        text: "Continue",
        onClick: confirmAction,
        disabled: disabled,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: () => {
          setDialogOpen(false);
        },
      }}
    >
      <>
        <Paragraph displayType="normal" colorType="secondary">
          {`This will send the client's treatment plan goals to ${syncOrg}. Once successfully synced, you will not be able to re-sync unless the sync fails.`}
        </Paragraph>
        <Paragraph displayType="normal" colorType="secondary" className="my-4">
          Would you like to proceed?
        </Paragraph>
        <div className="p-4 bg-red-50">
          <Paragraph displayType="loud" className="inline text-red-500!">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-500 inline mr-2" />
            Warning:{" "}
          </Paragraph>
          <Paragraph displayType="normal" colorType="secondary" className="inline text-red-500!">
            &nbsp; This will send data to {syncOrg}
          </Paragraph>
        </div>
      </>
    </Dialog>
  );
};
